/**
 * 不支持 嵌套打开
 */
import { App, render, createVNode, createApp } from 'vue'
import MicroDialog from './index.vue'

// 创建默认参数
const defaultOpt = {
  type: 'success'
}

let container: HTMLDivElement | null = null
let vNode: any | null = null

// 创建挂载实例
const createMount = (opts?: { [key: string]: any }) => {
  if (!vNode) {
    // 创建一个 div 容器, 把容器渲染到 body 上
    vNode = createVNode(MicroDialog, opts)
    if (!container) {
      container = document.createElement('div')
      document.body.appendChild(container)
    }
    // 把实例 render 到容器上
    render(vNode, container)
  }
  return vNode
}

function Dialog(opts?: { [key: string]: any }) {
  createMount().component?.exposed?.onOpen(opts)
}
Dialog.install = (app: App<Element>) => {
  app.component('microDialog', MicroDialog)
  app.provide('Dialog', Dialog)
  app.config.globalProperties.$microDialog = Dialog
}

Dialog.open = (opts?: { [key: string]: any }) => {
  createMount().component?.exposed?.onOpen(opts)
}

Dialog.close = (accId: string) => {
  createMount().component?.exposed?.onClose(accId)
}

/**
 * @description: 销毁 body 上的 实例
 * @param {HTMLDivElement} ele
 * @return {*}
 */
Dialog.remove = (ele?: HTMLDivElement): void => {
  if (container) {
    render(null, container)
    document.body.removeChild(container)
  }
}

export default Dialog
